'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWithFirebase = undefined;

var _withProps2 = require('recompose/withProps');

var _withProps3 = _interopRequireDefault(_withProps2);

var _compose2 = require('recompose/compose');

var _compose3 = _interopRequireDefault(_compose2);

var _withStore = require('./withStore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createWithFirebase = exports.createWithFirebase = function createWithFirebase(storeKey) {
  return (0, _compose3.default)((0, _withStore.createWithStore)(storeKey), (0, _withProps3.default)(function (_ref) {
    var _ref$store = _ref.store,
        firebase = _ref$store.firebase,
        dispatch = _ref$store.dispatch;
    return {
      firebase: firebase,
      dispatch: dispatch
    };
  }));
};

exports.default = createWithFirebase();


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-firebase/es/withFirebase.js
// module id = 929
// module chunks = 1